export const state = {
  userIds: [],
};
